<template>
  <div class="signout">
    <h1>Sign Out</h1>
  </div>
</template>
<script>
import eventBus from "../eventBus";
import { mapActions } from "vuex";
export default {
  name: "signout",
  created() {
    this.$store.dispatch("cognito/removeToken");
    eventBus.$emit("TOKEN_REMOVED", this.payload);
    this.$router.push("/"); //redirect to main page
  },
  methods: {
    ...mapActions(["cognito/removeToken"])
  }
};
</script>
